import { DeviceType } from 'src/types/DeviceType';
import { GenericDevice } from './GenericDevice';
import { formatDeviceName } from 'src/utils/formatDeviceName';

export class Device implements GenericDevice {
  id: string;

  type: DeviceType;

  serialNumber: string;

  sku: string;

  shortSerial: string;

  loraNetworkDetails: {
    devEUI: string;
    appKey: string;
    appEUI: string;
    frequencyPlan: 'AS923';
    network: 'SPARK_NZ' | 'TETHER_GATEWAY';
  };

  sigfoxNetworkDetails: {
    sigfoxId: string;
    sigfoxPAC: string;
    radioConfiguration: 'RC4';
  };

  mqttNetworkDetails?: {
    clientId: string;
    provisioningParameters?: {
      certificatePem?: string;
      privateKey?: string;
      endpointAddress?: string;
      topic?: string;
    };
  };

  hardwareVersion: string;

  firmwareVersion: string;

  manufacturingId?: string;

  parentDeviceId?: string;

  subDeviceIndex?: number;

  subDevices?: Device[];

  network?: string;

  createdAt: string;

  updatedAt: string;

  deletedAt: string;

  constructor(props: DeviceProperties) {
    Object.keys(props).forEach((key) => (this[key] = props[key]));
  }

  getDeviceType(): string {
    return this.type;
  }

  getFriendlyDeviceType(): string {
    return formatDeviceName(this.getDeviceType());
  }

  getPhysicalLabel(): string {
    switch (this.getDeviceType()) {
      case DeviceType.ENVIROQ:
      case DeviceType.THERMALQ:
        return this.shortSerial;
      default:
        return this.serialNumber;
    }
  }
}

export type DeviceProperties = Pick<
  Device,
  {
    [K in keyof Device]: Device[K] extends Function ? never : K;
  }[keyof Device]
>;
